"use client";
import { useMemo, useRef, useState } from "react";
import { Upload } from "lucide-react";
import { assetCategories } from "@/data/assets";
import { useEditorStore } from "@/stores/editorStore";
import { useSceneStore } from "@/stores/sceneStore";
import type { SceneObjectType } from "@/types/scene";

export function AssetLibrary() {
  const [category, setCategory] = useState("All");
  const [query, setQuery] = useState("");
  const fileRef = useRef<HTMLInputElement>(null);
  const assets = useSceneStore((state) => state.assets);
  const addFromAsset = useSceneStore((state) => state.addFromAsset);
  const addUploadedAsset = useSceneStore((state) => state.addUploadedAsset);
  const selectObject = useEditorStore((state) => state.selectObject);
  const filtered = useMemo(() => assets.filter((asset) => (category === "All" || asset.category === category) && asset.name.toLowerCase().includes(query.toLowerCase())), [assets, category, query]);
  const add = (assetId: string) => { const id = addFromAsset(assetId); if (id) selectObject(id); };
  const upload = (file?: File) => {
    if (!file) return;
    const id = `custom-${Date.now()}`;
    addUploadedAsset({ id, name: file.name.replace(/\.(glb|gltf)$/i, ""), category: "Farm Objects", thumbnail: "📦", modelUrl: URL.createObjectURL(file), type: "prop" as SceneObjectType });
    window.setTimeout(() => add(id), 0);
  };
  return <section className="panel-section">
    <div className="panel-title"><span>Asset Library</span><span>{filtered.length}</span></div>
    <input className="search" placeholder="Search assets…" value={query} onChange={(event) => setQuery(event.target.value)} />
    <div className="categories">{assetCategories.map((item) => <button key={item} className={`chip ${category === item ? "active" : ""}`} onClick={() => setCategory(item)}>{item}</button>)}</div>
    <button className="upload-button" onClick={() => fileRef.current?.click()}><Upload size={14} /> Import GLB / GLTF</button>
    <input ref={fileRef} hidden type="file" accept=".glb,.gltf,model/gltf-binary,model/gltf+json" onChange={(event) => upload(event.target.files?.[0])} />
    <div className="asset-grid">{filtered.map((asset) => <button className="asset-card" key={asset.id} draggable onDragStart={(event) => event.dataTransfer.setData("application/x-scene-asset", asset.id)} onClick={() => add(asset.id)} title={`Add ${asset.name}`}><span className="asset-preview"><span>{asset.thumbnail}</span></span><span className="asset-name">{asset.name}</span><span className="asset-type">{asset.category}</span></button>)}</div>
  </section>;
}
